import { useEffect, useState } from 'react'

const AddressLink = () => {
    const [address, setAddress] = useState('')
    // string aggregating constants
    const month = 'mai'

    useEffect(() => {
        // eslint-disable-next-line
        const localPart = 'ga' + '-lotse' + '.gesundheitsamt'
        // eslint-disable-next-line
        const domainPart = 'stadt' + '-frankfurt' + '.de'
        // join splited parts 
        setAddress(`${localPart}@${domainPart}`)
        }, [])

    if (!address) return null

    return (
        <a href={`${month}lto:${address}`} className="text-primary-plain-Color hover-link">
        {address}
        </a>
    )
}

export default AddressLink